import { render, staticRenderFns } from "./OficinasCaetanoRetailLogoPT.vue?vue&type=template&id=dc3caace&scoped=true&"
var script = {}
import style0 from "./OficinasCaetanoRetailLogoPT.vue?vue&type=style&index=0&id=dc3caace&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3caace",
  null
  
)

export default component.exports